import type { FileConfig } from '../types/FileConfig';

/**
 * Configuration objects for HopRx tool file types
 * Each config defines how to parse a specific HopRx CSV file format
 */
export const HOPRX_CONFIGS: Record<string, FileConfig> = {
  HOPRX_ICRUISE: {
    timeColumns: ['Time', 'Clock Ticks'],
    expectedColumns: ['Time', 'Clock Ticks', 'Event', 'Data'], // Event-based receiver operation data (hierarchical format)
    toolType: 'HopRx',
    fileType: 'EM_HOPRX_ICRUISE',
    dataType: 'timeseries'
  },
  HOPRX_VOLTAGES: {
    timeColumns: ['Time (seconds)', 'Clock Ticks (ms)'],
    expectedColumns: ['Clock Ticks (ms)', 'Time (seconds)', 'batt1_min (mV)', 'batt1_max (mV)', 'batt1_std_dev', 'batt1_mean (mV)', 'batt2_min (mV)', 'batt2_max (mV)', 'batt2_std_dev', 'batt2_mean (mV)', 'bbus_min (mV)', 'bbus_max (mV)', 'bbus_std_dev', 'bbus_mean (mV)', 'sys_cur_min (mA)', 'sys_cur_max (mA)', 'sys_cur_std_dev', 'sys_cur_mean (mA)', '1v8_min (mV)', '1v8_max (mV)', '1v8_std_dev', '1v8_mean (mV)', '3v3_min (mV)', '3v3_max (mV)', '3v3_std_dev', '3v3_mean (mV)', '5v0_min (mV)', '5v0_max (mV)', '5v0_std_dev', '5v0_mean (mV)', 'Temperature (celcius)'], // Complete voltage and current monitoring (30 columns)
    toolType: 'HopRx',
    fileType: 'EM_HOPRX_VOLTAGES',
    dataType: 'timeseries'
  },
  HOPRX_RXLOG: {
    timeColumns: [], // RXLOG files are comment-based error files - no timestamps
    expectedColumns: ['Error Message'], // Generic column name for error content
    toolType: 'HopRx',
    fileType: 'EM_HOPRX_RXLOG',
    dataType: 'timeseries'
  }
};